<p style="color:rgb(15, 15, 15);">Add Accessories Request:</p>
    <form [formGroup]="accessoriesRequestForm">
        <div *ngFor="let itemrow of accessoriesRequestForm?.get('itemRows')['controls']; let i=index"
            [formGroupName]="i">
            <h4 class="col-sm-1"> #{{i+1}}</h4>
            <div class="content-padding">
                <div class="row">
                    <div class="col-md-6">
                        <label>Accessories Type<sup class="required-sign">*</sup></label>
        
                        <select formControlName="accessoryId" class="form-control"
                            name="accessoryId" id="accessoryId" class="form-control"
                            [ngClass]="{'is-invalid': submitted && f.itemRows.controls[i].get('accessoryId').errors}">
                            <option *ngFor="let accessory of accessoriesList" [value]="accessory.accessoryId" class="drop">
                                <span>
                                    {{ accessory.item }} 
                                </span>
                            </option>
                        </select>
                        <div *ngIf="itemRows.controls[i].get('accessoryId')?.errors?.required && submitted"
                            class="invalid-feedback">
                            Accessories is required
                        </div>
                    </div>
        
                    <div class="col-md-6">
                        <label>Quantity<sup class="required-sign">*</sup></label>
                        <input type="number" class="form-control" formControlName="quantity" id="quantity" name="quantity"
                            pattern="^[1-9][0-9]*$" oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
                            placeholder="Enter Quantity"
                            [ngClass]="{ 'is-invalid': submitted && f.itemRows.controls[i].get('quantity').errors}">
                        <div *ngIf="itemRows.controls[i].get('quantity')?.errors?.required && submitted"
                            class="invalid-feedback">
                            Quantity is required
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Contact Person<sup class="required-sign">*</sup></label>
                        <input type="text" class="form-control" formControlName="contactPerson" id="contactPerson"
                            name="contactPerson" placeholder="Enter Contact Person"
                            [ngClass]="{ 'is-invalid': submitted && f.itemRows.controls[i].get('contactPerson').errors}">
                        <div *ngIf="itemRows.controls[i].get('contactPerson')?.errors?.required && submitted"
                            class="invalid-feedback">
                            Contact Person is required
                        </div>
                    </div>
        
                    <div class="col-md-6">
                        <label>Contact Number<sup class="required-sign">*</sup></label>
                        <input type="text" class="form-control" formControlName="contactNo" id="contactNo" name="contactNo"
                            placeholder="Enter Contact Number" minlength="9"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            maxlength="10" required autofocus
                            [ngClass]="{ 'is-invalid': submitted && f.itemRows.controls[i].get('contactNo').errors}">
                        <div *ngIf="itemRows.controls[i].get('contactNo')?.errors?.required && submitted"
                            class="invalid-feedback">
                            Contact Number is required
                        </div>
                        <!-- <label class="col-lg-6" for="name">Contact No<span class="required-sign"
                                    style="color: red">*</span></label>
                            <input type="text" class="form-control col-md-8" id="contactNo" name="contactNo" value=""
                                maxlength="10" formControlName="contactNo" placeholder="Contact Number"
                                [ngClass]="{'is-invalid': submitted && f.itemRows.controls[i].get('contactNo').errors}">
                            <div *ngIf="itemRows.controls[i].get('contactNo')?.errors?.required && submitted"class="invalid-feedback">
                                <div *ngIf="f.contactNo.errors.required">Contact Number is required</div>
                            </div> -->
                    </div>
        
                    <div class="col-md-6">
                        <label>Remarks<sup class="required-sign">*</sup></label>
                        <input type="text" class="form-control" formControlName="remarks" id="remarks" name="remarks"
                            placeholder="Enter Remarks"
                            [ngClass]="{ 'is-invalid': submitted && f.itemRows.controls[i].get('remarks').errors}">
                        <div *ngIf="itemRows.controls[i].get('remarks')?.errors?.required && submitted"
                            class="invalid-feedback">
                            Remarks is required
                        </div>
                    </div>
                </div>
                <br/>
                <button type="button" (click)="addNewRow()" class="btn btn-primary btn-sm">Add</button>
                <button *ngIf="accessoriesRequestForm.controls.itemRows.controls.length > 1"
                    (click)="deleteAccesoriesRequestRow(i)" class="btn btn-danger btn-sm"
                    style="margin-left:5px">Remove</button>
            </div>
        </div>
    </form>
